<template>
  <div>
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <!-- Summary Block -->
    <div class="wrap-block">
      <div
        v-for="(data, index) in summaryBlocks"
        :key="index"
        :style="styleDivBlock(data)"
        :class="data.type"
        class="summary-block"
      >
        <div class="item-name">{{ data.name }}</div>
        <hr>
        <div class="item-count">
          0 <span>record(s)</span>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <!-- Button -->
      <div class="d-flex align-items-center mb-2">
        <b-button
          v-if="type === 'requestor'"
          class="btn grey btn-import-form m__r--5"
          disabled
        >
          <i class="fa fa-plus fa-lg"/> Add
        </b-button>
        <b-button
          v-if="type === 'requestor'"
          class="btn grey btn-import-form m__r--5"
          disabled
        >
          <i class="fa fa-cloud-upload fa-lg"/> Import
        </b-button>
        <b-button
          class="btn grey btn-import-form"
          disabled
        >
          <i class="fa fa-search fa-lg"/> Search
        </b-button>
      </div>

      <!-- Columns -->
      <div class="columns">
        <div class="d-flex align-items-center">
          <div
            v-for="column in columns"
            :key="column"
            class="column"
          >
            <div
              class="header-list"
              style="cursor: default !important;"
            >
              <div class="column-name">{{ column }}</div>
            </div>
            <div
              v-for="index in 4"
              :key="index"
              :class="{'bg-gray': index === 2 || index === 4}"
              class="column-preview"
              style="cursor: default !important;"
            >
              <div class="content-preview"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      summaryBlockRequestor: [
        {
          key: 'draft',
          name: 'Draft',
          color: '#808285',
          type: 'first_block',
        },
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'middle_block',
        },
        {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'last_block',
        },
        {
          key: 'rejected',
          name: 'Rejected',
          color: '#8a0d4f',
          type: 'block',
        },
        {
          key: 'canceled',
          name: 'Canceled',
          color: '#d2232a',
          type: 'block',
        },
      ],
      summaryBlockApprover: [
        {
          key: 'sent',
          name: 'Sent',
          color: '#F36F21',
          type: 'first_block',
        },
        {
          key: 'approved',
          name: 'Approved',
          color: '#42A5CE',
          type: 'last_block',
        },
        {
          key: 'rejected',
          name: 'Rejected',
          color: '#8a0d4f',
          type: 'block',
        },
        {
          key: 'canceled',
          name: 'Canceled',
          color: '#d2232a',
          type: 'block',
        },
      ],
      columnsRequstor: [
        'EMPLOYEE ID',
        'EMPLOYEE NAME',
        'LOCATION',
        'START DATE',
        'END DATE',
        'TOTAL ATTENDANCE',
        'SUBMITED DATE',
        'UPDATED DATE',
      ],
      columnsApprover: [
        'ID',
        'EMPLOYEE ID',
        'EMPLOYEE NAME',
        'CHECK IN DATE',
        'CHECK OUT DATE',
        'PROJECT',
        'VENUE',
        'CHECK IN',
        'CHECK OUT',
        'REASON',
        'ATTACHMENT',
        'STATUS',
        'APPROVER COMMENT',
      ],
      summaryBlocks: [],
      columns: [],
    };
  },

  created() {
    if (this.type === 'requestor') {
      this.summaryBlocks = this.summaryBlockRequestor;
      this.columns = this.columnsRequstor;
    }
    if (this.type === 'approver') {
      this.summaryBlocks = this.summaryBlockApprover;
      this.columns = this.columnsApprover;
    }
  },

  methods: {
    styleDivBlock(item) {
      return { '--color': item.color };
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin block {
  content: "";
  position: absolute;
  display: inline-block;
  background-color: transparent;
  border-color: var(--color) var(--color) transparent transparent;
  border-style: solid;
  border-width: 2px 2px medium medium;
  transform: rotate(45deg);
}

@mixin before {
  @include block;
  top: 12px;
  width: 72px;
  height: 72px;
  border-radius: 5px;
  left: -36px;
  z-index: 1;
}

@mixin after {
  @include block;
  top: 11px;
  width: 75px;
  height: 74px;
  border-radius: 6px;
  right: -35px;
  z-index: 1;
}

.wrap-block {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;

  &::-webkit-scrollbar {
    display: none;
  }

  .summary-block {
    position: relative;
    min-width: 170px;
    height: 100px;
    padding: 6px 10px;
    border: 2px solid var(--color);
    border-radius: 6px;

    &.first_block {
      border-right: 0;
      border-radius: 6px 2px 2px 6px;
      margin-right: 12px;

      &::after {
        @include after;
      }
    }

    &.middle_block {
      min-width: 180px;
      border-left: 0;
      border-right: 0;
      border-radius: 2px;
      padding-left: 56px;
      margin-right: 12px;

      &::before {
        @include before;
      }
      &::after {
        @include after;
      }
    }

    &.last_block {
      min-width: 210px;
      border-left: 0;
      border-radius: 2px 6px 6px 2px;
      padding-left: 56px;
      margin-right: 10px;

      &::before {
        @include before;
      }
    }

    &.block {
      min-width: 190px;
      margin-right: 10px;
    }

    .item-name {
      font-family: 'Poppins-Medium';
      font-size: 14px;
      color: var(--color);
    }
    hr {
      margin: 0;
      margin-top: 4px;
      margin-bottom: 8px;
      border-top: 2px solid var(--color);
      width: 40px;
    }
    .item-count {
      font-family: 'Poppins-Semibold';
      font-size: 24px;
      color: var(--color);

      span {
        font-family: 'Poppins-Regular';
        font-size: 11px;
        color: var(--color);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyCoAttendance.vue